module.exports = __webpack_public_path__ + "static/comingsoonvest-55767ddcf71cf6752d71d02363285eb4.jpeg";